<template>
    <div class="main-content" v-if="$store.state.core.user">
        <div class="uk-padding">
            <img class="round" :src="$store.state.core.user.photoURL" />
            <h1>{{$store.state.core.user.displayName}}</h1>
            <img :src="$store.state.core.user.photoUrl"/>
            <p v-if="!$store.state.core.user.facebookLinked"><span class="uk-padding-small uk-text-danger" uk-icon="icon: close"></span>Not linked with Facebook</p>
            <p v-if="$store.state.core.user.facebookLinked"><span class="uk-padding-small uk-text-success" uk-icon="icon: check"></span>Linked with Facebook</p>
            <button class="uk-button uk-button-primary" v-if="!$store.state.core.user.facebookLinked" @click="linkFacebook">LINK WITH FACEBOOK</button>
            
            <router-link class="uk-button uk-button-secondary" to="wachtwoord-veranderen">Wachtwoord Veranderen</router-link>
            <ul>
                <li v-for="u in $store.state.core.user.moni">{{u}}</li>
            </ul>
            <ul>
                <li v-for="u in $store.state.core.user.vv">{{u}}</li>
            </ul>
        </div>
    </div>
    <div v-else>
    Loading..
    </div>
</template>
<script>
    import firebase from 'firebase'
    import {db, auth} from '@/CUSTOM/helpers/firebase'

    var facebook = new firebase.auth.FacebookAuthProvider()
    export default {
        name: 'Profile',
        methods: {
            linkFacebook () {
                auth.currentUser.linkWithPopup(facebook).then((result) => {
                    var credential = result.credential;
                    var user = result.user;
                    return db.collection('users').doc(auth.currentUser.uid).update({facebookLinked: true})
                }).then(()=> {
                    console.log('done')
                }).catch((error) => {
                    console.log(error)
                    if(error.code == 'auth/provider-already-linked'){
                        db.collection('users').doc(auth.currentUser.uid).update({facebookLinked: true}).then(() => {})
                    }
                });
            }
        }
        
    }
</script>


// WEBPACK FOOTER //
// Profile.vue?37195165